module.exports = __webpack_public_path__ + "static/media/02d.7fa13b08.svg";